/* eslint-disable */
import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import cookie from "react-cookies";
import { connect } from "react-redux";
import update from "immutability-helper";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import MenuNavigation from "./MenuNavigation";
import ProductList from "./ProductList";
import {
  appId,
  apiUrl,
  deliveryId,
  cookieConfig,
  headerconfig,
} from "../Helpers/Config";
import {
  showLoader,
  showAlert,
  getReferenceID,
} from "../Helpers/SettingHelper";
import {
  GET_GLOBAL_SETTINGS,
  GET_MENU_NAVIGATION,
  GET_ZONE_DETAIL,
} from "../../actions";
import legand from "../../common/images/single-strip.svg";
import mobilelegand from "../../common/images/strip-1.svg";
import mobilelegand1 from "../../common/images/strip-2.svg";

const isEqual = require("react-fast-compare");
var Parser = require("html-react-parser");

class Products extends Component {
  constructor(props) {
    super(props);
    var normalpopupFlg = "initial";
    if (
      (cookie.load("triggerAvlPop") != "" &&
        cookie.load("triggerAvlPop") != undefined) ||
      cookie.load("orderPopuptrigger") === "Yes" ||
      cookie.load("loginpopupTrigger") === "Yes" ||
      cookie.load("promoPopupTrigger") === "Yes"
    ) {
      normalpopupFlg = "trigger";
    }
    this.state = {
      navigateMenu: [],
      selectedCategoryName: "",
      selectedNavigation: "",
      selectedSlugType: "",
      searchSubCat: "",
      searchProVal: "",
      viewProductSlug: "",
      catNavIndex: 0,
      catslugType: "",
      catslugValue: "",
      cartTriggerFlg: "No",
      searchProResult: [],
      selectedProResult: [],
      /* tagList: "", */
      filterTag: [],
      setFiltetTag: "No",
      productload: "Yes",
      openOutletTime: false,
      normalpopup_flg: normalpopupFlg,
      normalpopupstatus: "initial",
      staticblacks: [],
      hometopcontent: "",
    };

    /* var orderOutletId = cookie.load("orderOutletId");
    if (orderOutletId === "" || orderOutletId === undefined) {
      cookie.save("orderPopuptrigger", "Yes", cookieConfig);
      this.props.history.push("/");
      return;
    } */

    if (cookie.load("MemberLoginFlg") === "Success") {
      var MemberLoginId = cookie.load("MemberLoginId");
      cookie.remove("MemberLoginFlg", { path: "/" });
      cookie.remove("MemberLoginId", { path: "/" });
      if (MemberLoginId !== "") {
        this.customerLoginById(MemberLoginId);
      }
    }

    this.props.getSettings();
    /* this.loadTags(); */
    var availbty = cookie.load("defaultAvilablityId");
    var outltIdTxt =
      typeof cookie.load("orderOutletId") === "undefined"
        ? ""
        : cookie.load("orderOutletId");
    var zoneIdTxt =
      typeof cookie.load("orderZoneId") === "undefined"
        ? ""
        : cookie.load("orderZoneId");

    if (availbty === deliveryId && outltIdTxt !== "" && zoneIdTxt !== "") {
      this.state["delivery_outlet_id"] = outltIdTxt;
      this.props.getZoneDetail(outltIdTxt, zoneIdTxt);
    }
    this.props.getMenuNavigationList();
  }

  componentWillReceiveProps(nextProps) {
    /*if(this.state.selectedCategoryName!==nextProps.selectedCatry){
			this.setState({selectedCategoryName: nextProps.selectedCatry});
		}*/
    let slugType =
      typeof this.props.match.params.slugType !== "undefined"
        ? this.props.match.params.slugType
        : "";
    let slugValue =
      typeof this.props.match.params.slugValue !== "undefined"
        ? this.props.match.params.slugValue
        : "";
    let proValue =
      typeof this.props.match.params.proValue !== "undefined"
        ? this.props.match.params.proValue
        : "";
    let selectedNavigation = nextProps.selectedNavigation;
    let selectedSlugType = nextProps.selectedSlugType;
    var searchSubCat = "";
    if (!isEqual(this.props.match.params, nextProps.match.params)) {
      slugType =
        typeof nextProps.match.params.slugType !== "undefined"
          ? nextProps.match.params.slugType
          : "";
      slugValue =
        typeof nextProps.match.params.slugValue !== "undefined"
          ? nextProps.match.params.slugValue
          : "";
      proValue =
        typeof nextProps.match.params.proValue !== "undefined"
          ? nextProps.match.params.proValue
          : "";
    }

    if (slugValue !== "") {
      if (slugType !== "category" && slugType !== "subcategory") {
        searchSubCat = slugValue;
        slugValue = slugType;
        slugType = "category";
        /*$('.search_result').hide();*/
        var tmpVl = "";
        $("#productsearch").val(tmpVl);
        $("#clearSearch").hide();
        $(".hsearch_sec").removeClass("open");
        $(".hsearch_trigger").removeClass("active");
        setTimeout(function () {
          $(window).scrollTo($("." + proValue), 100);
        }, 2000);
      }
      selectedNavigation = slugValue;
    }

    if (slugType === "") {
      slugType = selectedSlugType;
    }
    /*  ||
      this.state.selectedCategoryName !== nextProps.selectedCatry */
    if (selectedNavigation !== this.state.selectedNavigation) {
      showLoader("productlist-main-div", "class");

      if (slugType === "subcategory") {
        var navIndex = nextProps.navigateMenu.findIndex(
          (p) => p.pro_subcate_slug == selectedNavigation
        );
        var categoryNameTxt =
          Object.keys(nextProps.navigateMenu).length > 0
            ? nextProps.navigateMenu[navIndex].subcategory_name
            : nextProps.selectedCatry;
      } else {
        var navIndex = nextProps.navigateMenu.findIndex(
          (p) => p.pro_cate_slug == selectedNavigation
        );
        var categoryNameTxt =
          Object.keys(nextProps.navigateMenu).length > 0
            ? nextProps.navigateMenu[navIndex].category_name
            : nextProps.selectedCatry;
      }
      this.setState({
        selectedNavigation: selectedNavigation,
        navigateMenu: nextProps.navigateMenu,
        catNavIndex: navIndex,
        catslugType: slugType,
        catslugValue: slugValue,
        selectedCategoryName: categoryNameTxt,
        searchSubCat: searchSubCat,
        searchProVal: proValue,
      });
    }

    if (nextProps.staticblack !== this.state.staticblacks) {
      var hometopcontent = "";

      if (Object.keys(nextProps.staticblack).length > 0) {
        nextProps.staticblack.map((data) => {
          if (data.staticblocks_slug === "home-top-content") {
            hometopcontent = data.staticblocks_description;
            return "";
          }
        });
      }
      hometopcontent =
        hometopcontent !== "" && hometopcontent !== null
          ? Parser(hometopcontent)
          : hometopcontent;

      this.setState({
        staticblacks: nextProps.staticblack,
        hometopcontent: hometopcontent,
      });
    }
  }

  componentDidMount() {
    if (cookie.load("memberloginpopupTrigger") === "Yes") {
      cookie.save("memberloginpopupTrigger", "fromcheckout", cookieConfig);
      cookie.save("loginpopupTrigger", "fromcheckout", cookieConfig);
      $.magnificPopup.open({
        items: {
          src: "#membership-form-popup",
        },
        type: "inline",
      });
    }

    if (cookie.load("memberrenewalpopupTrigger") === "Yes") {
      cookie.save("memberrenewalpopupTrigger", "myaccount", cookieConfig);
      $.magnificPopup.open({
        items: {
          src: "#member-renewal-popup",
        },
        type: "inline",
      });
    }

    var MemberrenewalFlg =
      typeof cookie.load("MemberrenewalFlg") === "undefined"
        ? ""
        : cookie.load("MemberrenewalFlg");
    var MemberrenewalInfo =
      typeof cookie.load("MemberrenewalInfo") === "undefined"
        ? ""
        : cookie.load("MemberrenewalInfo");
    if (MemberrenewalFlg !== "") {
      cookie.remove("MemberrenewalFlg", { path: "/" });
      cookie.remove("MemberrenewalInfo", { path: "/" });
      if (MemberrenewalFlg === "Success") {
        showAlert(
          "Success",
          "Congratulations ! We have received your payment for Sushi Tei Membership. You will receive one email from us for the payment confirmation and one more for membership renewal. Please keep a look out for these emails."
        );
        $.magnificPopup.open({
          items: {
            src: ".alert_popup",
          },
          type: "inline",
        });
      } else {
        var errMsgtxt =
          MemberrenewalInfo !== ""
            ? MemberrenewalInfo
            : "Sorry! did not renewal your membership account.";
        showAlert("Error", errMsgtxt);
        $.magnificPopup.open({
          items: {
            src: ".alert_popup",
          },
          type: "inline",
        });
      }
    }

    if (
      cookie.load("defaultAvilablityId") === "" ||
      typeof cookie.load("defaultAvilablityId") === undefined ||
      typeof cookie.load("defaultAvilablityId") === "undefined"
    ) {
      $.magnificPopup.open({
        items: {
          src: "#order-popup",
        },
        type: "inline",
      });
    }

    if (cookie.load("orderPopuptrigger") === "Yes") {
      cookie.remove("orderPopuptrigger", cookieConfig);
      $.magnificPopup.open({
        items: {
          src: "#order-popup",
        },
        type: "inline",
      });
    }

    if (cookie.load("loginpopupTrigger") === "Yes") {
      cookie.save("loginpopupTrigger", "fromcheckout", cookieConfig);
      $.magnificPopup.open({
        items: {
          src: "#login-popup",
        },
        type: "inline",
      });
    }

    /*SCROLL FIXED PRODUCT PAGE*/
    $(document).click(function (e) {
      if (!$(e.target).is(".hsearch_trigger, .hsearch_sec, .hsearch_sec * ")) {
        if ($(".product_search_result").is(":visible")) {
          $(".product_search_result").hide();
          $("#searchKeyWord").val("");
        }
      }
    });

    $(window).scroll(function () {
      var productlist_height = $(".productlist-main-div").offset();
      if (productlist_height !== undefined) {
        var mycustomscroll = $(".productlist-main-div").offset().top - 122,
          wind_toptxt = $(window).scrollTop();

        if (wind_toptxt > mycustomscroll) {
          $(".bakery_row").addClass("catogry_row_fixed");
        } else {
          $(".bakery_row").removeClass("catogry_row_fixed");
        }
      }
    });
    $(".product_search_result").hide();
  }

  customerLoginById(MemberLoginId) {
    var postObject = {};
    postObject = { app_id: appId, cust_id: MemberLoginId };
    var qs = require("qs");
    axios
      .post(
        apiUrl + "customer/loginById",
        qs.stringify(postObject),
        headerconfig
      )
      .then((res) => {
        if (res.data.status === "ok") {
          var fbloginData = res.data;
          var mobileno = "",
            cust_birthdate = "";
          if (
            typeof fbloginData.result_set.customer_phone === "undefined" ||
            fbloginData.result_set.customer_phone === "null" ||
            fbloginData.result_set.customer_phone === ""
          ) {
            mobileno = "";
          } else {
            mobileno = fbloginData.result_set.customer_phone;
          }

          if (
            typeof fbloginData.result_set.customer_birthdate !== "undefined" &&
            fbloginData.result_set.customer_birthdate !== "null" &&
            fbloginData.result_set.customer_birthdate !== null &&
            fbloginData.result_set.customer_birthdate !== "" &&
            fbloginData.result_set.customer_birthdate !== "0000-00-00"
          ) {
            cust_birthdate = fbloginData.result_set.customer_birthdate;
          }
          cookie.save("UserId", fbloginData.result_set.customer_id, {
            path: "/",
          });
          sessionStorage.setItem(
            "mytime",
            new Date(Date.now() + timeInterval * 240000)
          );
          cookie.save(
            "AcentisMemberid",
            fbloginData.result_set.ascentis_memberid
          );
          cookie.save(
            "AscentisCardNo",
            fbloginData.result_set.ascentis_card_no
          );
          cookie.save(
            "AscentisMemberPhone",
            fbloginData.result_set.ascentis_member_phone
          );
          cookie.save(
            "AscentisMemberPassword",
            fbloginData.result_set.ascentis_member_password
          );
          cookie.save(
            "AscentisMemberCreatedfrom",
            fbloginData.result_set.ascentis_member_createdfrom
          );
          cookie.save(
            "AscentisMemberPayment",
            fbloginData.result_set.ascentis_member_payment
          );

          cookie.save("UserEmail", fbloginData.result_set.customer_email, {
            path: "/",
          });
          cookie.save(
            "UserFname",
            fbloginData.result_set.customer_first_name !== ""
              ? fbloginData.result_set.customer_first_name
              : "",
            { path: "/" }
          );
          cookie.save(
            "UserLname",
            fbloginData.result_set.customer_last_name !== ""
              ? fbloginData.result_set.customer_last_name
              : "",
            { path: "/" }
          );
          cookie.save("UserMobile", mobileno, { path: "/" });
          cookie.save("UserBirthdate", cust_birthdate, { path: "/" });
          cookie.save(
            "UserDefaultAddress",
            fbloginData.result_set.customer_address_name,
            { path: "/" }
          );
          cookie.save(
            "UserDefaultUnitOne",
            fbloginData.result_set.customer_address_line1,
            { path: "/" }
          );
          cookie.save(
            "UserDefaultUnitTwo",
            fbloginData.result_set.customer_address_line2,
            { path: "/" }
          );
          cookie.save(
            "UserDefaultPostalCode",
            fbloginData.result_set.customer_postal_code,
            { path: "/" }
          );
          cookie.save(
            "access_token",
            fbloginData.result_set.access_token,
            cookieConfig
          );
          const { history } = this.props;
          var qs = require("qs");
          var postObject = {
            app_id: appId,
            reference_id: getReferenceID(),
            customer_id: fbloginData.result_set.customer_id,
            availability_id: cookie.load("defaultAvilablityId"),
          };

          axios
            .post(
              apiUrl + "cart/update_customer_info",
              qs.stringify(postObject),
              {
                headers: {
                  "x-api-key": "W6W3SUXRTC7J5JUT6OYTWB14DBG718",
                  Authorization: fbloginData.result_set.access_token,
                },
              }
            )
            .then((res) => {
              showAlert(
                "Success",
                "Congratulations ! We have received your payment for Sushi Tei Membership. You will receive one email from us for the payment confirmation and one more for membership activation. Please keep a look out for these emails."
              );
              $.magnificPopup.open({
                items: {
                  src: ".alert_popup",
                },
                type: "inline",
              });
              if (res.data.status === "ok") {
                if (cookie.load("loginpopupTrigger") === "fromcheckout") {
                  cookie.remove("loginpopupTrigger", { path: "/" });
                  history.push("/checkout");
                } else {
                  history.push("/myaccount");
                }
              } else {
                console.log(
                  "frmdmsnnb",
                  cookie.load("memberloginpopupTrigger")
                );
                if (cookie.load("memberloginpopupTrigger") === "fromcheckout") {
                  cookie.remove("memberloginpopupTrigger", { path: "/" });
                  history.push("/checkout");
                } else {
                  history.push("/myaccount");
                }
              }
            });
        } else if (res.data.status === "error") {
          var errMsgtxt =
            res.data.message !== "" ? res.data.message : "Invalid login id.";
          showAlert("Error", errMsgtxt);
          $.magnificPopup.open({
            items: {
              src: ".alert_popup",
            },
            type: "inline",
          });
        }

        return false;
      });
  }

  sateValChange = (field, value) => {
    if (field === "cartflg") {
      this.setState({ cartTriggerFlg: value });
    } else if (field === "view_pro_data" && value !== "") {
      this.setState(
        { viewProductSlug: value },
        function () {
          this.openProDetailPopup();
        }.bind(this)
      );
    } else if (field === "productlist" && value !== "") {
      this.setState({
        searchProResult: value,
        selectedProResult: value,
      });
    } else if (field === "setFiltetTag" && value !== "") {
      this.setState({
        setFiltetTag: value,
      });
    } else if (field === "openOutletTime" && value !== "") {
      this.setState(
        {
          openOutletTime: value,
        },
        function () {
          this.props.sateValChange("openOutletTime", value);
        }
      );
    }
  };

  productFlageChange = (field, value) => {
    this.setState(
      update(this.state, { productflage: { [field]: { $set: value } } })
    );
  };

  openProDetailPopup() {
    showLoader("comboPro-" + this.state.viewProductSlug, "Idtext");
    /*$("#ProductDetailMdl").modal({ backdrop: "static", keyboard: false });*/
  }

  searchProKeyPress = (event) => {
    var value = event.target.value.toLowerCase(),
      matches = this.state.searchProResult.filter(function (item) {
        if (item.label.toLowerCase().indexOf(value) >= 0) {
          return value;
        }
      });

    $("#product_search_result").show();
    if (value === "") {
      $("#product_search_result").hide();
    }
    this.setState({ selectedProResult: matches });
  };

  /* load product search result  */
  loadProSearchList() {
    if (Object.keys(this.state.selectedProResult).length > 0) {
      return this.state.selectedProResult.map((loaddata, index) => (
        <li key={index}>
          <Link
            to={
              "/menu/" +
              loaddata.cate_slug +
              "/" +
              loaddata.subcate_slug +
              "/" +
              loaddata.value
            }
            title="Product Details"
          >
            {loaddata.label}
          </Link>
        </li>
      ));
    } else {
      return <li className="no-pro-found">No Product found</li>;
    }
  }

  /* loadTags() {
    axios
      .get(apiUrl + "/menu/product_tags?app_id=" + appId + "&status=A", headerconfig)
      .then((res) => {
    
        if (res.data.status === "ok") {
          this.displayTag(res.data.result_set);
        } else {
        }
      });
  }
 */
  /* displayTag(tags) {
    let tagList = "";
    if (tags !== "") {
      var current = this;
      tagList = tags.map(function (item, index) {
        return (
          <li className="custom_checkbox" key={index}>
            <input
              type="checkbox"
              className="restaurants_tag"
              value={item.pro_tag_id}
              onChange={(e) => current.handleChange(current, e)}
            />
            <span>
              <img
                src={tagImageUrl + "" + item.pro_tag_image}
                alt={item.pro_tag_name}
              />
              {item.pro_tag_name}
            </span>
          </li>
        );
      });
    }
    this.setState({ tagList: tagList });
  } */

  handleChange(section, event) {
    let filterTag = section.state.filterTag;
    if (event.target.checked === true) {
      filterTag.push(event.target.value);
    } else {
      var index = filterTag.indexOf(event.target.value);
      filterTag.splice(index, 1);
    }
    section.setState({ filterTag: filterTag, setFiltetTag: "Yes" });
  }
  clearFilter(event) {
    event.preventDefault();
    $(".restaurants_tag").prop("checked", false);
    this.setState({ filterTag: [], setFiltetTag: "Yes" });
  }

  render() {
    return (
      <div className="productpage-main-div">
        {/* Header start */}
        <Header
          cartTriggerFlg={this.state.cartTriggerFlg}
          sateValChange={this.sateValChange}
          showCatryName={this.state.selectedCategoryName}
        />
        {/* Header End */}
        {this.state.hometopcontent}

        <section className="product-menu-listing">
          <div className="container">
            <div className="product-menu-left">
              <MenuNavigation
                {...this.props}
                productState={this.state}
                sateValChange={this.sateValChange}
              />
            </div>
            <div className="product-lhs">
              <ProductList
                {...this.props}
                productState={this.state}
                sateValChange={this.sateValChange}
              />
            </div>
          </div>
        </section>
        {/* Footer section */}
        <div id="dvLoading" className="dvLoadrCls"></div>
        <div className="legand-img">
          <div className="container">
            <img src={legand} className="desktop-legand-img" />
            <div className="mobile-legand">
              <img src={mobilelegand} className="mobile-legand-img" />
              <img src={mobilelegand1} className="mobile-legand-img" />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var tempArr = Array();
  var menu_slug = "";
  var menu_type = "";
  var navigateRst = Array();
  var navigateCmn = Array();
  var selectedCatry = "";
  if (Object.keys(state.product).length > 0) {
    $("#dvLoading").hide();
    var tempArr = !("menuNavigation" in state.product[0])
      ? Array()
      : state.product[0].menuNavigation;
    if (Object.keys(tempArr).length > 0) {
      if (tempArr[0].status === "ok") {
        navigateRst = tempArr[0].result_set;
        navigateCmn = tempArr[0].common;
        if (tempArr[0].result_set[0].menu_type == "main") {
          selectedCatry = tempArr[0].result_set[0].category_name;
          menu_slug = tempArr[0].result_set[0].pro_cate_slug;
          menu_type = "category";
        } else {
          selectedCatry = tempArr[0].result_set[0].subcategory_name;
          menu_slug = tempArr[0].result_set[0].pro_subcate_slug;
          menu_type = "subcategory";
        }
      }
    }
  }

  var zonedetailArr = Array();
  if (Object.keys(state.zonedetail).length > 0) {
    if (state.zonedetail[0].status === "ok") {
      zonedetailArr = state.zonedetail[0].result_set;
    }
  }
  var blacksArr = Array();
  if (Object.keys(state.staticblack).length > 0) {
    if (state.staticblack[0].status === "ok") {
      blacksArr = state.staticblack[0].result_set;
    }
  }

  return {
    globalsettings: state.settings,
    navigateMenu: navigateRst,
    navigateCommon: navigateCmn,
    selectedCatry: selectedCatry,
    selectedNavigation: menu_slug,
    selectedSlugType: menu_type,
    zonedetails: zonedetailArr,
    staticblack: blacksArr,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSettings: () => {
      dispatch({ type: GET_GLOBAL_SETTINGS });
    },
    getZoneDetail: (outletId, zoneId) => {
      dispatch({ type: GET_ZONE_DETAIL, outletId, zoneId });
    },
    getMenuNavigationList: () => {
      dispatch({ type: GET_MENU_NAVIGATION });
    },
  };
};
export default connect(mapStateTopProps, mapDispatchToProps)(Products);
